
<div class="modal fade" id="labCartModal" tabindex="-1" role="dialog" aria-labelledby="viewImage" aria-hidden="true" >
  <div class="modal-dialog  modal-xl" role="document">
    <div class="modal-content">
      <button class="no-border-btn doc-close-btn" data-dismiss="modal">
        <img src="../../../assets/images/cross-icon-3.svg" alt="cross-icon" width="24px" height="24px">
      </button>
      <div class="modal-header">
        <div class="row">
          <div class="col-12">
            ID: {{selectedCart.cartId}}
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <table class="table">
                <tbody>
                    <tr style="background:transparent !important;cursor: initial !important;"
                    *ngIf="selectedCart.flag">
                      <td colspan="4" class="height-240" style="position:relative;border:none;">
                        <div class="row">
                          <div class="col-6 stroke-right" style="border-right: 2px solid rgba(61, 72, 86, 0.30);" 
                          *ngIf="selectedCart.cartDetails">
                            <div class="details-1-card">
                              <div class="row auto-height-41">
                                <div class="col-6 left">Colour:</div>
                                <div class="col-6 right">{{selectedCart.cartDetails.cartColour}}</div>
                              </div>
                              <div class="row auto-height-41">
                                <div class="col-6 left">Quantity:</div>
                                <div class="col-6 right">{{selectedCart.cartDetails.totalQuantity}}</div>
                              </div>
                              <div class="row auto-height-41">
                                <div class="col-6 left">Date of creation:</div>
                                <div class="col-6 right" *ngIf="selectedCart.cartDetails.dateOfCartCreation">
                                  {{selectedCart.cartDetails.dateOfCartCreation|date:'dd/MM/yyyy'}}
                                </div>
                                <div class="col-6 right" *ngIf="!selectedCart.cartDetails.dateOfCartCreation">
                                  -
                                </div>
                              </div>
                              <div class="row auto-height-41">
                                <div class="col-6 left">Created by:</div>
                                <div class="col-6 right">{{selectedCart.cartDetails.adminName}}</div>
                              </div>
                              <div class="row auto-height-41">
                                <div class="col-6 left">Location:</div>
                                <div class="col-6 right">{{selectedCart.cartDetails.location}}</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-6" style="max-height: 300px;overflow-y: auto;">
                            <table class="table inner-table">
                              <thead style="border: 1px solid rgba(61, 72, 86, 0.30);">
                                <tr>
                                  <th scope="col">Sample type</th>
                                  <th scope="col">Sample ID</th>
                                  <th scope="col">Status by</th>
                                </tr>
                              </thead>
                              <tbody style="border: 1px solid rgba(61, 72, 86, 0.30);">
                                <ng-container *ngIf="selectedCart.cartDetails && selectedCart.cartDetails.sampleDetails">
                                  <tr *ngFor="let task of selectedCart.cartDetails.sampleDetails">
                                    <td>{{task.sampleType}}</td>
                                    <td>{{task.sampleId}}</td>
                                    <td>{{task.status}}</td>
                                  </tr>
                                </ng-container>
                                <tr *ngIf="selectedCart.cartDetails && 
                                selectedCart.cartDetails.sampleDetails && selectedCart.cartDetails.sampleDetails.length == 0">
                                  <td colspan="3">There is no cart details</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </td>
                    </tr>
                </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="position: absolute; bottom: 0px; right: 0px;">
        <div class="row">
          <div class="col-auto ml-auto">
            <div class="content-center">
              <!-- <button class="btn-1 circle-btn red-border"  data-dismiss="modal" style="width:32px; height:32px" (click)="onRejectDoc()"
              [disabled]="!editAccess">
                <img src="../../../assets/images/cross-icon.svg" alt="cross-icon" width="21px" height="21px">
              </button>
              <button class="btn-1 ml-24 circle-btn green-border" data-dismiss="modal" style="width:32px; height:32px" (click)="onAcceptDoc()"
              [disabled]="!editAccess">
                <img src="../../../assets/images/tick-icon.svg" alt="tick-icon" width="21px" height="21px">
              </button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>